import { useState } from 'react';
// @mui
import {
  Box,
  Divider,
  IconButton,
  MenuItem,
  Popover,
  Stack,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { LogoutIcon } from '../nav/IconButton';
import { PersonIcon } from './HeaderStyle';
import { useNavigate } from 'react-router-dom';
import { useLogout } from '../../../hooks/useLogout';
import { ModalText, useModalToggle } from '../../../components/modal/Modal';
import { ApproveModal } from '../../../components/modal/ApproveModal';

export default function AccountPopover() {
  const [open, setOpen] = useState<HTMLElement | null>(null);
  const navigate = useNavigate();

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
    navigate(`/users/me`);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              position: 'absolute',
              bgcolor: (theme: any) => alpha(theme.palette.grey[900], 0),
            },
          }),
        }}
      >
        <PersonIcon />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={() => setOpen(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 140,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleClose} sx={{ m: 1 }}>
          내 계정
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed', mb: '0px !important' }} />
        <LogoutMenu />
      </Popover>
    </>
  );
}

function LogoutMenu() {
  const { logout } = useLogout();
  const { on, open, close } = useModalToggle();
  return (
    <>
      <Stack sx={{ p: 1 }} direction="row" alignItems="center">
        <MenuItem onClick={open} sx={{ flex: 1 }}>
          로그아웃
          <Box sx={{ width: '12px' }} /> <LogoutIcon />
        </MenuItem>
      </Stack>
      <ApproveModal
        title="로그아웃"
        on={on}
        onClose={close}
        onConfirm={logout}
        isPrimaryColor={false}
      >
        <Stack direction="row" justifyContent="center" sx={{ pt: 3, pb: 5 }}>
          <ModalText>로그아웃 하시겠습니까?</ModalText>
        </Stack>
      </ApproveModal>
    </>
  );
}
